import { Brick, registerBrick } from 'olympe';

export default class AddMultMaterialToGatewayFilter extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {ListDef} material
     * @param {string} body
     * @param {function()} forwardEvent
     * @param {function(string)} setBody
     */
    update($, [material, body], [forwardEvent, setBody]) {
        
        // Parse the string b into a JSON object
        let query = JSON.parse(body);
        // Initialize the filters array
        let filters = [];
        // Create filters based on the input list Material
        material.forEach((item, index) => {
            filters.push({ field: "plant", value: item.plantId, operator: "=", group: index });
            filters.push({ field: "material", value: item.materialId, operator: "=", group: index });
            filters.push({ field: "vendorSite", value: item.alternativeVendorId, operator: "=", group: index });
        });
        // Add filters to the query object
        query.filters = filters;
        // Output the result
        const output = JSON.stringify(query);
        setBody(output);

        forwardEvent();
    }
}

registerBrick('0191308ea43a10901ba9', AddMultMaterialToGatewayFilter);
